var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column min-vh-100 vw-mobile",staticStyle:{"background-color":"white"},attrs:{"id":"app"}},[_c('Nav',{staticStyle:{"font-color":"black"}}),_c('div',{staticClass:"wrapper flex-grow-1",staticStyle:{"display":"flex","flex-direction":"column"}},[_c('router-view')],1),(_vm.pageCheck)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }